import { css } from '@emotion/react'
import "focus-visible/dist/focus-visible"

import { mediaStyle } from './src/contexts/responsive'

const flexFullHeight = css`
  flex: 1;
  display: flex;
  flex-direction: column;
`

export default css`
  @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@400;500;700&display=swap');
  html {
    height: 100%;
    background-color: black;
  }
  body {
    min-width: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
  }
  #___gatsby {
    ${flexFullHeight}
    > #gatsby-focus-wrapper {
      ${flexFullHeight}
      > main {
        ${flexFullHeight}
        > div:not(.fresnel-container) {
          flex: 1;
        }
      }
    }
  }

  ${mediaStyle}
`;
